/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminOrganizationUserGetDuplicateWarningParams,
  AdminOrganizationUserGetOrganizationUsersParams,
  ConsolidateOrganizationUsersDTO,
  CreateAnonymousOrganizationUserDTO,
  DuplicateOrganizationUserWarningDTO,
  OrganizationUserAdminDTO,
  OrganizationUserConsolidationPreviewDTO,
  OrganizationUserListItemDTOQueryResultDTO,
  SetPasswordDTO,
  UpdateAnonymousOrganizationUserDTO,
  UpdateOrganizationUserDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminOrganizationUserGetOrganizationUser = (
    organizationId: number,
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUserAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationUserGetOrganizationUserQueryKey = (organizationId: number,
    id: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationUser/${id}`] as const;
    }

    
export const getAdminOrganizationUserGetOrganizationUserQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError = ErrorType<unknown>>(organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationUserGetOrganizationUserQueryKey(organizationId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>> = ({ signal }) => adminOrganizationUserGetOrganizationUser(organizationId,id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationUserGetOrganizationUserQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>>
export type AdminOrganizationUserGetOrganizationUserQueryError = ErrorType<unknown>


export function useAdminOrganizationUserGetOrganizationUser<TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationUserGetOrganizationUser<TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationUserGetOrganizationUser<TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationUserGetOrganizationUser<TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUser>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationUserGetOrganizationUserQueryOptions(organizationId,id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationUserGetOrganizationUsers = (
    organizationId: number,
    params?: AdminOrganizationUserGetOrganizationUsersParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUserListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminOrganizationUserGetOrganizationUsersQueryKey = (organizationId: number,
    params?: AdminOrganizationUserGetOrganizationUsersParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationUser`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminOrganizationUserGetOrganizationUsersQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminOrganizationUserGetOrganizationUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationUserGetOrganizationUsersQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>> = ({ signal }) => adminOrganizationUserGetOrganizationUsers(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationUserGetOrganizationUsersQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>>
export type AdminOrganizationUserGetOrganizationUsersQueryError = ErrorType<unknown>


export function useAdminOrganizationUserGetOrganizationUsers<TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminOrganizationUserGetOrganizationUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationUserGetOrganizationUsers<TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationUserGetOrganizationUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationUserGetOrganizationUsers<TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationUserGetOrganizationUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationUserGetOrganizationUsers<TData = Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationUserGetOrganizationUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetOrganizationUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationUserGetOrganizationUsersQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationUserUpdateAnonymousOrganizationUser = (
    organizationId: number,
    organizationUserId: number,
    updateAnonymousOrganizationUserDTO: UpdateAnonymousOrganizationUserDTO,
 ) => {
      
      
      return customInstance<OrganizationUserAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser/anonymous/${organizationUserId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAnonymousOrganizationUserDTO
    },
      );
    }
  


export const getAdminOrganizationUserUpdateAnonymousOrganizationUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserUpdateAnonymousOrganizationUser>>, TError,{organizationId: number;organizationUserId: number;data: UpdateAnonymousOrganizationUserDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserUpdateAnonymousOrganizationUser>>, TError,{organizationId: number;organizationUserId: number;data: UpdateAnonymousOrganizationUserDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationUserUpdateAnonymousOrganizationUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationUserUpdateAnonymousOrganizationUser>>, {organizationId: number;organizationUserId: number;data: UpdateAnonymousOrganizationUserDTO}> = (props) => {
          const {organizationId,organizationUserId,data} = props ?? {};

          return  adminOrganizationUserUpdateAnonymousOrganizationUser(organizationId,organizationUserId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationUserUpdateAnonymousOrganizationUserMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserUpdateAnonymousOrganizationUser>>>
    export type AdminOrganizationUserUpdateAnonymousOrganizationUserMutationBody = UpdateAnonymousOrganizationUserDTO
    export type AdminOrganizationUserUpdateAnonymousOrganizationUserMutationError = ErrorType<unknown>

    export const useAdminOrganizationUserUpdateAnonymousOrganizationUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserUpdateAnonymousOrganizationUser>>, TError,{organizationId: number;organizationUserId: number;data: UpdateAnonymousOrganizationUserDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationUserUpdateAnonymousOrganizationUser>>,
        TError,
        {organizationId: number;organizationUserId: number;data: UpdateAnonymousOrganizationUserDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationUserUpdateAnonymousOrganizationUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationUserAddAnonymousUserToOrganization = (
    organizationId: number,
    createAnonymousOrganizationUserDTO: CreateAnonymousOrganizationUserDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUserAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser/add-anonymous`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAnonymousOrganizationUserDTO, signal
    },
      );
    }
  


export const getAdminOrganizationUserAddAnonymousUserToOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserAddAnonymousUserToOrganization>>, TError,{organizationId: number;data: CreateAnonymousOrganizationUserDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserAddAnonymousUserToOrganization>>, TError,{organizationId: number;data: CreateAnonymousOrganizationUserDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationUserAddAnonymousUserToOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationUserAddAnonymousUserToOrganization>>, {organizationId: number;data: CreateAnonymousOrganizationUserDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminOrganizationUserAddAnonymousUserToOrganization(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationUserAddAnonymousUserToOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserAddAnonymousUserToOrganization>>>
    export type AdminOrganizationUserAddAnonymousUserToOrganizationMutationBody = CreateAnonymousOrganizationUserDTO
    export type AdminOrganizationUserAddAnonymousUserToOrganizationMutationError = ErrorType<unknown>

    export const useAdminOrganizationUserAddAnonymousUserToOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserAddAnonymousUserToOrganization>>, TError,{organizationId: number;data: CreateAnonymousOrganizationUserDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationUserAddAnonymousUserToOrganization>>,
        TError,
        {organizationId: number;data: CreateAnonymousOrganizationUserDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationUserAddAnonymousUserToOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationUserGetDuplicateWarning = (
    organizationId: number,
    params?: AdminOrganizationUserGetDuplicateWarningParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DuplicateOrganizationUserWarningDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser/duplicate-warning`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminOrganizationUserGetDuplicateWarningQueryKey = (organizationId: number,
    params?: AdminOrganizationUserGetDuplicateWarningParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationUser/duplicate-warning`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminOrganizationUserGetDuplicateWarningQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminOrganizationUserGetDuplicateWarningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationUserGetDuplicateWarningQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>> = ({ signal }) => adminOrganizationUserGetDuplicateWarning(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationUserGetDuplicateWarningQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>>
export type AdminOrganizationUserGetDuplicateWarningQueryError = ErrorType<unknown>


export function useAdminOrganizationUserGetDuplicateWarning<TData = Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminOrganizationUserGetDuplicateWarningParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationUserGetDuplicateWarning<TData = Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationUserGetDuplicateWarningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationUserGetDuplicateWarning<TData = Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationUserGetDuplicateWarningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationUserGetDuplicateWarning<TData = Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationUserGetDuplicateWarningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetDuplicateWarning>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationUserGetDuplicateWarningQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationUserGetConsolidationPreview = (
    organizationId: number,
    organizationUserId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUserConsolidationPreviewDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser/${organizationUserId}/consolidation-preview`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationUserGetConsolidationPreviewQueryKey = (organizationId: number,
    organizationUserId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationUser/${organizationUserId}/consolidation-preview`] as const;
    }

    
export const getAdminOrganizationUserGetConsolidationPreviewQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError = ErrorType<unknown>>(organizationId: number,
    organizationUserId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationUserGetConsolidationPreviewQueryKey(organizationId,organizationUserId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>> = ({ signal }) => adminOrganizationUserGetConsolidationPreview(organizationId,organizationUserId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && organizationUserId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationUserGetConsolidationPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>>
export type AdminOrganizationUserGetConsolidationPreviewQueryError = ErrorType<unknown>


export function useAdminOrganizationUserGetConsolidationPreview<TData = Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError = ErrorType<unknown>>(
 organizationId: number,
    organizationUserId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationUserGetConsolidationPreview<TData = Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError = ErrorType<unknown>>(
 organizationId: number,
    organizationUserId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationUserGetConsolidationPreview<TData = Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError = ErrorType<unknown>>(
 organizationId: number,
    organizationUserId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationUserGetConsolidationPreview<TData = Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError = ErrorType<unknown>>(
 organizationId: number,
    organizationUserId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationUserGetConsolidationPreview>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationUserGetConsolidationPreviewQueryOptions(organizationId,organizationUserId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationUserConsolidateProfiles = (
    organizationId: number,
    consolidateOrganizationUsersDTO: ConsolidateOrganizationUsersDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser/consolidate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: consolidateOrganizationUsersDTO, signal
    },
      );
    }
  


export const getAdminOrganizationUserConsolidateProfilesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserConsolidateProfiles>>, TError,{organizationId: number;data: ConsolidateOrganizationUsersDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserConsolidateProfiles>>, TError,{organizationId: number;data: ConsolidateOrganizationUsersDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationUserConsolidateProfiles'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationUserConsolidateProfiles>>, {organizationId: number;data: ConsolidateOrganizationUsersDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminOrganizationUserConsolidateProfiles(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationUserConsolidateProfilesMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserConsolidateProfiles>>>
    export type AdminOrganizationUserConsolidateProfilesMutationBody = ConsolidateOrganizationUsersDTO
    export type AdminOrganizationUserConsolidateProfilesMutationError = ErrorType<unknown>

    export const useAdminOrganizationUserConsolidateProfiles = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserConsolidateProfiles>>, TError,{organizationId: number;data: ConsolidateOrganizationUsersDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationUserConsolidateProfiles>>,
        TError,
        {organizationId: number;data: ConsolidateOrganizationUsersDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationUserConsolidateProfilesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationUserUpdateOrganizationUser = (
    organizationId: number,
    organizationUserId: number,
    updateOrganizationUserDTO: UpdateOrganizationUserDTO,
 ) => {
      
      
      return customInstance<OrganizationUserAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser/${organizationUserId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationUserDTO
    },
      );
    }
  


export const getAdminOrganizationUserUpdateOrganizationUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserUpdateOrganizationUser>>, TError,{organizationId: number;organizationUserId: number;data: UpdateOrganizationUserDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserUpdateOrganizationUser>>, TError,{organizationId: number;organizationUserId: number;data: UpdateOrganizationUserDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationUserUpdateOrganizationUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationUserUpdateOrganizationUser>>, {organizationId: number;organizationUserId: number;data: UpdateOrganizationUserDTO}> = (props) => {
          const {organizationId,organizationUserId,data} = props ?? {};

          return  adminOrganizationUserUpdateOrganizationUser(organizationId,organizationUserId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationUserUpdateOrganizationUserMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserUpdateOrganizationUser>>>
    export type AdminOrganizationUserUpdateOrganizationUserMutationBody = UpdateOrganizationUserDTO
    export type AdminOrganizationUserUpdateOrganizationUserMutationError = ErrorType<unknown>

    export const useAdminOrganizationUserUpdateOrganizationUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserUpdateOrganizationUser>>, TError,{organizationId: number;organizationUserId: number;data: UpdateOrganizationUserDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationUserUpdateOrganizationUser>>,
        TError,
        {organizationId: number;organizationUserId: number;data: UpdateOrganizationUserDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationUserUpdateOrganizationUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationUserAssignRole = (
    organizationId: number,
    organizationUserId: number,
    organizationRoleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUserAdminDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser/${organizationUserId}/assign-role/${organizationRoleId}`, method: 'POST', signal
    },
      );
    }
  


export const getAdminOrganizationUserAssignRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserAssignRole>>, TError,{organizationId: number;organizationUserId: number;organizationRoleId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserAssignRole>>, TError,{organizationId: number;organizationUserId: number;organizationRoleId: number}, TContext> => {
    
const mutationKey = ['adminOrganizationUserAssignRole'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationUserAssignRole>>, {organizationId: number;organizationUserId: number;organizationRoleId: number}> = (props) => {
          const {organizationId,organizationUserId,organizationRoleId} = props ?? {};

          return  adminOrganizationUserAssignRole(organizationId,organizationUserId,organizationRoleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationUserAssignRoleMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserAssignRole>>>
    
    export type AdminOrganizationUserAssignRoleMutationError = ErrorType<unknown>

    export const useAdminOrganizationUserAssignRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserAssignRole>>, TError,{organizationId: number;organizationUserId: number;organizationRoleId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationUserAssignRole>>,
        TError,
        {organizationId: number;organizationUserId: number;organizationRoleId: number},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationUserAssignRoleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationUserSetPasswordForOrganizationUser = (
    organizationId: number,
    organizationUserId: number,
    setPasswordDTO: SetPasswordDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationUser/set-password/${organizationUserId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setPasswordDTO, signal
    },
      );
    }
  


export const getAdminOrganizationUserSetPasswordForOrganizationUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserSetPasswordForOrganizationUser>>, TError,{organizationId: number;organizationUserId: number;data: SetPasswordDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserSetPasswordForOrganizationUser>>, TError,{organizationId: number;organizationUserId: number;data: SetPasswordDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationUserSetPasswordForOrganizationUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationUserSetPasswordForOrganizationUser>>, {organizationId: number;organizationUserId: number;data: SetPasswordDTO}> = (props) => {
          const {organizationId,organizationUserId,data} = props ?? {};

          return  adminOrganizationUserSetPasswordForOrganizationUser(organizationId,organizationUserId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationUserSetPasswordForOrganizationUserMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationUserSetPasswordForOrganizationUser>>>
    export type AdminOrganizationUserSetPasswordForOrganizationUserMutationBody = SetPasswordDTO
    export type AdminOrganizationUserSetPasswordForOrganizationUserMutationError = ErrorType<unknown>

    export const useAdminOrganizationUserSetPasswordForOrganizationUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationUserSetPasswordForOrganizationUser>>, TError,{organizationId: number;organizationUserId: number;data: SetPasswordDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationUserSetPasswordForOrganizationUser>>,
        TError,
        {organizationId: number;organizationUserId: number;data: SetPasswordDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationUserSetPasswordForOrganizationUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    